import React from 'react';

import { BasicInput, BasicInputProps } from './BasicInput';
import { TotemLabel } from './TotemLabel';

type TotemInputProps = Omit<BasicInputProps, 'onChange'> & {
    className?: string;
    onChange: (value: string) => void;
    label?: string;
    sublabel?: string;
    dataTest?: string;
    textColor?: string;
    inputRef?: React.RefObject<HTMLInputElement>;
};

export const TotemInput = ({ label, sublabel, onChange, dataTest, inputRef, className, ...props }: TotemInputProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {
            target: { value },
        } = e;
        onChange(value);
    };

    return (
        <div className={`flex flex-col gap-[5px] ${className || ''}`}>
            {label ? <TotemLabel>{label}</TotemLabel> : null}
            {sublabel ? <span className="text-muted-foreground text-[13px]">{sublabel}</span> : null}
            <BasicInput ref={inputRef} onChange={handleChange} data-test={dataTest} {...props} />
        </div>
    );
};
